import React from "react";

const WishlistPage = () => {
  return (
    <div>
      <p>This is my wishList...</p>
    </div>
  );
};

export default WishlistPage;
